/* GLOSS theme cart + UI logic, wired to Shopify's real Cart AJAX API
   (Ajax API docs: /cart/add.js, /cart.js, /cart/change.js)           */
(function () {
  var routes = (window.GLOSS && window.GLOSS.routes) || {
    cartAdd: "/cart/add.js",
    cart: "/cart.js",
    cartChange: "/cart/change.js",
  };
  var strings = (window.GLOSS && window.GLOSS.strings) || {
    remove: "remove",
    addedPrefix: "Added:",
    addError: "Couldn't add to cart",
    modelLabel: "Model:",
    decreaseQty: "Decrease quantity",
    increaseQty: "Increase quantity",
    cartEmpty: "Your cart is empty.",
    cartEmptyCta: "Let's fix that ✦",
    qtySuffix: "__N__ pcs",
  };
  function qtyText(n) {
    return strings.qtySuffix.replace("__N__", n);
  }

  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = routes.moneyFormat || "{{amount}}";
    // Shopify's money_format can use several placeholder variants
    // ({{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}}, etc.)
    // — match whichever one is actually present rather than a fixed name.
    return format.replace(/\{\{\s*[a-z_]+\s*\}\}/, amount);
  }

  function showToast(msg) {
    var t = $("#toast");
    if (!t) return;
    $("#toastMsg").textContent = msg;
    t.classList.add("show");
    clearTimeout(showToast._timer);
    showToast._timer = setTimeout(function () {
      t.classList.remove("show");
    }, 2200);
  }

  function openCart() {
    $("#drawer").classList.add("open");
    $("#overlay").classList.add("open");
  }
  function closeCart() {
    $("#drawer").classList.remove("open");
    $("#overlay").classList.remove("open");
  }

  function propsLine(item) {
    if (!item.properties) return "";
    var parts = [];
    for (var k in item.properties) {
      if (Object.prototype.hasOwnProperty.call(item.properties, k) && item.properties[k]) {
        parts.push(k + ": " + item.properties[k]);
      }
    }
    return parts.length ? '<div class="ci__price">' + parts.join(", ") + "</div>" : "";
  }

  function renderCart(cart) {
    var count = cart.item_count || 0;
    var bag = $("#bagCount");
    if (bag) bag.textContent = count;

    var body = $("#cartBody");
    if (!body) return;

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="drawer__empty"><div class="big">🛍</div>' + strings.cartEmpty + "<br>" + strings.cartEmptyCta + "</div>";
    } else {
      body.innerHTML = cart.items
        .map(function (item, i) {
          var img = item.image
            ? '<img src="' + item.image + '" alt="' + (item.product_title || "") + '">'
            : "📱";
          return (
            '<div class="ci" data-key="' +
            item.key +
            '">' +
            '<div class="ci__img">' +
            img +
            "</div>" +
            '<div class="ci__info">' +
            '<div class="ci__name">' +
            item.product_title +
            (item.variant_title && item.variant_title !== "Default Title"
              ? " · " + item.variant_title
              : "") +
            "</div>" +
            propsLine(item) +
            '<div class="ci__price">' +
            formatMoney(item.final_line_price) +
            " · " +
            qtyText(item.quantity) +
            "</div>" +
            '<button class="ci__rm" data-key="' +
            item.key +
            '">' +
            strings.remove +
            "</button>" +
            "</div>" +
            "</div>"
          );
        })
        .join("");
    }

    var total = $("#cartTotal");
    if (total) total.textContent = formatMoney(cart.total_price);

    var checkoutBtn = $("#checkoutBtn");
    if (checkoutBtn) checkoutBtn.disabled = count === 0;
  }

  function renderCartPage(cart) {
    var empty = $("#cartPageEmpty");
    var body = $("#cartPageBody");
    if (!empty || !body) return;

    if (!cart.items || cart.items.length === 0) {
      empty.style.display = "";
      body.style.display = "none";
      return;
    }
    empty.style.display = "none";
    body.style.display = "";

    var items = $("#cartPageItems");
    if (items) {
      items.innerHTML = cart.items
        .map(function (item) {
          var img = item.image
            ? '<img src="' + item.image + '" alt="' + (item.product_title || "") + '">'
            : "📱";
          var modelLine =
            item.variant_title && item.variant_title !== "Default Title"
              ? '<div class="ci__price">' + strings.modelLabel + " " + item.variant_title + "</div>"
              : "";
          modelLine += propsLine(item);
          return (
            '<div class="ci" data-key="' +
            item.key +
            '" style="align-items:center">' +
            '<div class="ci__img" style="width:64px">' +
            img +
            "</div>" +
            '<div class="ci__info">' +
            '<div class="ci__name">' +
            item.product_title +
            "</div>" +
            modelLine +
            '<div class="ci__price">' +
            formatMoney(item.price) +
            " × <span data-qty-display>" +
            item.quantity +
            "</span> = <span data-line-total>" +
            formatMoney(item.line_price) +
            "</span></div>" +
            "</div>" +
            '<div style="display:flex;align-items:center;gap:10px">' +
            '<div style="display:flex;align-items:center;border:2px solid var(--ink);border-radius:100px;overflow:hidden">' +
            '<button type="button" class="cart-qty-btn" data-qty-minus data-key="' +
            item.key +
            '" aria-label="' + strings.decreaseQty + '" style="width:32px;height:32px;border:none;background:var(--cream);cursor:pointer;font-weight:700">−</button>' +
            '<span data-qty style="min-width:26px;text-align:center;font-family:var(--mono);font-size:.9rem">' +
            item.quantity +
            "</span>" +
            '<button type="button" class="cart-qty-btn" data-qty-plus data-key="' +
            item.key +
            '" aria-label="' + strings.increaseQty + '" style="width:32px;height:32px;border:none;background:var(--cream);cursor:pointer;font-weight:700">+</button>' +
            "</div>" +
            '<button type="button" class="ci__rm" data-key="' +
            item.key +
            '">' + strings.remove + "</button>" +
            "</div>" +
            "</div>"
          );
        })
        .join("");
    }
    var total = $("#cartPageTotal");
    if (total) total.textContent = formatMoney(cart.total_price);
  }

  function refreshCart() {
    fetch(routes.cart)
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        renderCartPage(cart);
      })
      .catch(function () {});
  }

  function addToCart(variantId, qty, properties) {
    qty = qty || 1;
    var payload = { id: variantId, quantity: qty };
    if (properties) payload.properties = properties;
    return fetch(routes.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add-to-cart failed");
        return r.json();
      })
      .then(function (item) {
        showToast(strings.addedPrefix + " " + item.product_title);
        refreshCart();
        openCart();
        return item;
      })
      .catch(function () {
        showToast(strings.addError);
      });
  }

  function removeFromCart(key) {
    fetch(routes.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        renderCartPage(cart);
      })
      .catch(function () {});
  }

  function setQuantity(key, qty) {
    if (qty < 0) qty = 0;
    fetch(routes.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
        renderCartPage(cart);
      })
      .catch(function () {});
  }

  document.addEventListener("DOMContentLoaded", function () {
    refreshCart();

    document.addEventListener("click", function (e) {
      var addBtn = e.target.closest("[data-add-to-cart]");
      if (addBtn) {
        e.preventDefault();
        var variantId = addBtn.getAttribute("data-variant-id");
        var nameField = document.querySelector("[data-custom-name]");
        var properties = null;
        if (nameField && nameField.value.trim()) {
          properties = { Name: nameField.value.trim() };
        }
        if (variantId) addToCart(variantId, 1, properties);
      }

      var rmBtn = e.target.closest(".ci__rm");
      if (rmBtn) {
        removeFromCart(rmBtn.getAttribute("data-key"));
      }

      var plusBtn = e.target.closest("[data-qty-plus]");
      if (plusBtn) {
        var row = plusBtn.closest(".ci");
        var current = row ? parseInt((row.querySelector("[data-qty]") || {}).textContent || "0", 10) : 0;
        setQuantity(plusBtn.getAttribute("data-key"), current + 1);
      }

      var minusBtn = e.target.closest("[data-qty-minus]");
      if (minusBtn) {
        var row2 = minusBtn.closest(".ci");
        var current2 = row2 ? parseInt((row2.querySelector("[data-qty]") || {}).textContent || "0", 10) : 0;
        setQuantity(minusBtn.getAttribute("data-key"), current2 - 1);
      }

      var favBtn = e.target.closest(".card__fav");
      if (favBtn) {
        favBtn.textContent = favBtn.textContent.trim() === "🤍" ? "💗" : "🤍";
      }

      if (e.target.closest("#openCart")) {
        e.preventDefault();
        openCart();
      }
      if (e.target.closest("#closeCart") || e.target.id === "overlay") {
        closeCart();
      }
      if (e.target.closest(".burger")) {
        var links = $(".nav__links");
        if (links) links.classList.toggle("open");
      }
    });

    document.addEventListener("change", function (e) {
      var select = e.target.closest("[data-variant-select]");
      if (select) {
        var form = select.closest(".product-main__form");
        var btn = form && form.querySelector("[data-add-to-cart]");
        if (btn) btn.setAttribute("data-variant-id", select.value);
      }
    });
  });

  window.GLOSS = window.GLOSS || {};
  window.GLOSS.addToCart = addToCart;
  window.GLOSS.refreshCart = refreshCart;
})();
